import React from 'react';
import PropTypes from 'prop-types';
import CustomReactMarkdown from '../../shared/components/MarkdownRenderers/CustomReactMarkdown';

function Description({ shortDescription, longDescription }) {
    return (
        <>
            {shortDescription && (
              <div className="product-description__left-col">
                <h2 className="product-description__title">Description</h2>
                <CustomReactMarkdown className="product-description__short-description" source={shortDescription} />
              </div>
            )}
            {longDescription && (
              <div className="product-description__right-col">
                <h2 className="product-description__title">Features</h2>
                <CustomReactMarkdown className="product-description__long-description" source={longDescription} />
              </div>
            )}
        </>
    );
}

Description.propTypes = {
  shortDescription: PropTypes.string.isRequired,
  longDescription: PropTypes.string.isRequired,
};

export default Description;
